import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'

import './header.css'

const Header = (props) => {
  const image = !props.image ? false : (
    <div className='page-header__img'>
      <img src={props.image} alt={props.title} />
    </div>
  )

  const prevLink = !props.href ? false : (
    <Link to={props.href}>{props.backTo} /</Link>
  )

  const subtitle = !props.subtitle ? false : (
    <p>{props.subtitle}</p>
  )

  return (
    <div className='page-header'>
      <h1>{prevLink} {ReactHtmlParser(props.title)}</h1>
      { subtitle }
      { image }
    </div>
  )
}

Header.propTypes = {
  href: PropTypes.string,
  backTo: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  image: PropTypes.string
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Page/Header/index.js